import type { WorkflowStepKey } from './types'

/** Routes with no workflow step (trail hidden). */
export const OUT_OF_FLOW_PATHS = new Set([
  '/login',
  '/settings',
  '/users',
  '/audit',
  '/support-tickets',
  '/observability',
  '/health-checks',
  '/test-runner',
  '/admin/data-reset',
  '/admin/compliance-workflow',
])

/** Dashboard: show trail but no highlighted step. */
export const OVERVIEW_PATHS = new Set(['/'])

export interface AppRouteEntry {
  pattern: string
  stepKey: WorkflowStepKey | null
  label: string
}

/** Every App.tsx route for admin unmapped-route warnings. */
export const APP_ROUTE_REGISTRY: AppRouteEntry[] = [
  { pattern: '/', stepKey: null, label: 'Dashboard (overview)' },
  { pattern: '/login', stepKey: null, label: 'Login' },
  { pattern: '/master-terms', stepKey: 'master-terms', label: 'Master terms' },
  { pattern: '/term-watches', stepKey: 'master-terms', label: 'Term watcher' },
  { pattern: '/pim', stepKey: 'compliance-setup', label: 'Compliance setup' },
  { pattern: '/products', stepKey: 'products', label: 'Products' },
  { pattern: '/products/orphaned', stepKey: 'products', label: 'Orphaned products' },
  { pattern: '/products/:productId', stepKey: 'products', label: 'Product detail' },
  { pattern: '/products/:productId/details', stepKey: 'products', label: 'Product details' },
  { pattern: '/products/:productId/pim-manual', stepKey: 'products', label: 'PIM manual editor' },
  { pattern: '/products/:productId/compliance-scope', stepKey: 'products', label: 'Compliance scope' },
  { pattern: '/products/:productId/compare', stepKey: 'products', label: 'Product compare' },
  { pattern: '/rules', stepKey: 'rule-packs', label: 'Rule packs' },
  { pattern: '/rules/:rulePackId', stepKey: 'rule-packs', label: 'Rule pack detail' },
  { pattern: '/extraction-profiles/:profileId', stepKey: 'rule-packs', label: 'Extraction profile detail' },
  { pattern: '/distributors', stepKey: 'distributors-targets', label: 'Distributors' },
  { pattern: '/distributors/:distributorId/search', stepKey: 'distributors-targets', label: 'Distributor search' },
  { pattern: '/targets', stepKey: 'distributors-targets', label: 'Targets' },
  { pattern: '/run-checks', stepKey: 'run-checks', label: 'Run checks' },
  { pattern: '/check-runs', stepKey: 'run-checks', label: 'Jobs list' },
  { pattern: '/check-runs/:checkRunId', stepKey: 'run-checks', label: 'Job detail' },
  { pattern: '/findings', stepKey: 'findings-reports', label: 'Findings' },
  { pattern: '/distributor-action-reports', stepKey: 'findings-reports', label: 'Distributor reports' },
  { pattern: '/actions', stepKey: 'findings-reports', label: 'Actions' },
  { pattern: '/compliance-audit', stepKey: 'findings-reports', label: 'Compliance audit hub' },
  { pattern: '/settings', stepKey: null, label: 'Settings' },
  { pattern: '/users', stepKey: null, label: 'Users' },
  { pattern: '/audit', stepKey: null, label: 'Audit log' },
  { pattern: '/support-tickets', stepKey: null, label: 'Support tickets' },
  { pattern: '/observability', stepKey: null, label: 'Observability' },
  { pattern: '/health-checks', stepKey: null, label: 'Health checks' },
  { pattern: '/test-runner', stepKey: null, label: 'Test runner' },
  { pattern: '/admin/data-reset', stepKey: null, label: 'Admin data reset' },
  { pattern: '/admin/compliance-workflow', stepKey: null, label: 'Compliance workflow admin' },
]
